// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__v9US4","desabilitar":"OptionSelect_desabilitar__cyjq9","focado":"OptionSelect_focado__eqDhx","novo":"OptionSelect_novo__rU29G"};